<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-35 md-small-size-hide">
      <main-table :data="data" :lease="true" />
    </div>
    <div class="md-layout-item md-size-65 md-small-size-100">
      <h4 class="header-table">Sensibilidad Renta</h4>
      <md-table class="sensibility-table">
        <md-table-row>
          <md-table-cell class="first">&nbsp;</md-table-cell>
          <md-table-cell class="header">Variación</md-table-cell>
          <md-table-cell class="header">-10%</md-table-cell>
          <md-table-cell class="header">-5%</md-table-cell>
          <md-table-cell class="header">0%</md-table-cell>
          <md-table-cell class="header">+5%</md-table-cell>
          <md-table-cell class="header">+10%</md-table-cell>
        </md-table-row>
        <md-table-row>
          <md-table-cell>Variación</md-table-cell>
          <md-table-cell>Rinde / Precio</md-table-cell>
          <md-table-cell>{{ formatNumber(data['-10_precio_usd_t']) }} USD/t</md-table-cell>
          <md-table-cell>{{ formatNumber(data['-5_precio_usd_t']) }} USD/t</md-table-cell>
          <md-table-cell>{{ formatNumber(data['0_precio_usd_t']) }} USD/t</md-table-cell>
          <md-table-cell>{{ formatNumber(data['5_precio_usd_t']) }} USD/t</md-table-cell>
          <md-table-cell>{{ formatNumber(data['10_precio_usd_t']) }} USD/t</md-table-cell>
        </md-table-row>
        <md-table-row>
          <md-table-cell class="header">-20%</md-table-cell>
          <md-table-cell class="header">{{ formatNumber(data['-20_rinde']) }}</md-table-cell>
          <md-table-cell
            :style="'background-color:' + getStyleColor(data['-10_-20'])">{{ formatNumber(data['-10_-20']) }}%</md-table-cell>
          <md-table-cell :style="'background-color:' + getStyleColor(data['-5_-20'])">{{ formatNumber(data['-5_-20']) }}%</md-table-cell>
          <md-table-cell :style="'background-color:' + getStyleColor(data['0_-20'])">{{ formatNumber(data['0_-20']) }}%</md-table-cell>
          <md-table-cell :style="'background-color:' + getStyleColor(data['5_-20'])">{{ formatNumber(data['5_-20']) }}%</md-table-cell>
          <md-table-cell :style="'background-color:' + getStyleColor(data['10_-20'])">{{ formatNumber(data['10_-20']) }}%</md-table-cell>
        </md-table-row>
        <md-table-row>
          <md-table-cell class="header">-10%</md-table-cell>
          <md-table-cell class="header">{{ formatNumber(data['-10_rinde']) }}</md-table-cell>
          <md-table-cell
            :style="'background-color:' + getStyleColor(data['-10_-10'])">{{ formatNumber(data['-10_-10']) }}%</md-table-cell>
          <md-table-cell :style="'background-color:' + getStyleColor(data['-5_-10'])">{{ formatNumber(data['-5_-10']) }}%</md-table-cell>
          <md-table-cell :style="'background-color:' + getStyleColor(data['0_-10'])">{{ formatNumber(data['0_-10']) }}%</md-table-cell>
          <md-table-cell :style="'background-color:' + getStyleColor(data['5_-10'])">{{ formatNumber(data['5_-10']) }}%</md-table-cell>
          <md-table-cell :style="'background-color:' + getStyleColor(data['10_-10'])">{{ formatNumber(data['10_-10']) }}%</md-table-cell>
        </md-table-row>
        <md-table-row>
          <md-table-cell>0%</md-table-cell>
          <md-table-cell class="header">{{ formatNumber(data['0_rinde']) }}</md-table-cell>
          <md-table-cell :style="'background-color:' + getStyleColor(data['-10_0'])">{{ formatNumber(data['-10_0']) }}%</md-table-cell>
          <md-table-cell :style="'background-color:' + getStyleColor(data['-5_0'])">{{ formatNumber(data['-5_0']) }}%</md-table-cell>
          <md-table-cell :style="'background-color:' + getStyleColor(data['0_0'])">{{ formatNumber(data['0_0']) }}%</md-table-cell>
          <md-table-cell :style="'background-color:' + getStyleColor(data['5_0'])">{{ formatNumber(data['5_0']) }}%</md-table-cell>
          <md-table-cell :style="'background-color:' + getStyleColor(data['10_0'])">{{ formatNumber(data['10_0']) }}%</md-table-cell>
        </md-table-row>
        <md-table-row>
          <md-table-cell>+10%</md-table-cell>
          <md-table-cell class="header">{{ formatNumber(data['10_rinde']) }}</md-table-cell>
          <md-table-cell :style="'background-color:' + getStyleColor(data['-10_10'])">{{ formatNumber(data['-10_10']) }}%</md-table-cell>
          <md-table-cell :style="'background-color:' + getStyleColor(data['-5_10'])">{{ formatNumber(data['-5_10']) }}%</md-table-cell>
          <md-table-cell :style="'background-color:' + getStyleColor(data['0_10'])">{{ formatNumber(data['0_10']) }}%</md-table-cell>
          <md-table-cell :style="'background-color:' + getStyleColor(data['5_10'])">{{ formatNumber(data['5_10']) }}%</md-table-cell>
          <md-table-cell :style="'background-color:' + getStyleColor(data['10_10'])">{{ formatNumber(data['10_10']) }}%</md-table-cell>
        </md-table-row>
        <md-table-row>
          <md-table-cell>+20%</md-table-cell>
          <md-table-cell class="header">{{ formatNumber(data['20_rinde']) }}</md-table-cell>
          <md-table-cell :style="'background-color:' + getStyleColor(data['-10_20'])">{{ formatNumber(data['-10_20']) }}%</md-table-cell>
          <md-table-cell :style="'background-color:' + getStyleColor(data['-5_20'])">{{ formatNumber(data['-5_20']) }}%</md-table-cell>
          <md-table-cell :style="'background-color:' + getStyleColor(data['0_20'])">{{ formatNumber(data['0_20']) }}%</md-table-cell>
          <md-table-cell :style="'background-color:' + getStyleColor(data['5_20'])">{{ formatNumber(data['5_20']) }}%</md-table-cell>
          <md-table-cell :style="'background-color:' + getStyleColor(data['10_20'])">{{ formatNumber(data['10_20']) }}%</md-table-cell>
        </md-table-row>
      </md-table>
    </div>
  </div>
</template>

<script>

import MainTable from '@/components/MainTable';

export default {
  name: 'sensibility',
  components: { MainTable },
  props: ['data'],
  methods: {
    getStyleColor(rawValue) {
      // Accepts numbers or strings like "-12", "8", "15%"
      const n = parseFloat(rawValue);

      if (!Number.isFinite(n)) {
        return 'transparent';
      }

      // Clamp range
      const min = -100;
      const max = 100;
      const v = Math.max(min, Math.min(max, n));

      let hue;

      if (v <= 0) {
        // Red (0°) -> Yellow (60°)
        // v: -100 -> 0
        const ratio = (v - min) / (0 - min); // 0..1
        hue = ratio * 60;
      } else {
        // Yellow (60°) -> Green (120°)
        // v: 0 -> 100
        const ratio = v / max; // 0..1
        hue = 60 + ratio * 60;
      }

      return `hsl(${hue}, 85%, 55%)`;
    },
    formatNumber(value) {
      if (value === null || value === undefined || value === '') return '';
      const num = Number(value);
      if (Number.isNaN(num)) return value;

      if (Number.isInteger(num)) return String(num).replace('.', ',');
      return num.toFixed(1).replace('.', ',');
    }
  }
}
</script>
<style>
.sensibility-table .md-table-row td {
  border: 1px solid #ddd;
  text-align: center;
  /* width: 20%; */
}

.sensibility-table .md-table-row .first {
  border-left: none;
  border-top: none;
}

.sensibility-table .md-table-row .header {
  height: 18px;
  padding: 3px;
}

.sensibility-table .md-table-row .header {
  background-color: '#ddd'
}

.sensibility-table .md-table-cell {
  padding: 3px;
  height: 38px
}

.header-table {
  color: '#333';
  margin-top: 0;
  margin-bottom: 10px;
}
</style>
